(function () {
  var THRESHOLD = 30000; // $300.00 in cents
  var GIFT_IMAGE = 'https://cdn.shopify.com/s/files/1/0047/6191/1396/files/mother-s-day-gift-box_img01.jpg?v=1777340439';

  var BASE_STYLE = [
    'display:flex',
    'flex-direction:column',
    'gap:4px',
    'padding:12px 16px',
    'border-radius:8px',
    'font-size:14px',
    'line-height:1.5',
    'transition:background-color 0.25s ease, border-color 0.25s ease',
  ].join(';');

  var PENDING_STYLE  = 'background-color:#faf2ef;border:1px solid #D29082;color:#333';
  var UNLOCKED_STYLE = 'background-color:#edfaf3;border:1px solid #a3d9bb;color:#1a6640';

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(0);
  }

  function renderBlocks(totalPrice) {
    var isUnlocked = totalPrice >= THRESHOLD;
    var remaining  = THRESHOLD - totalPrice;
    var style      = BASE_STYLE + ';' + (isUnlocked ? UNLOCKED_STYLE : PENDING_STYLE);

    var iconBg     = isUnlocked ? '#1a6640' : 'transparent';
    var iconColor  = isUnlocked ? '#fff'    : 'initial';
    var iconSymbol = isUnlocked ? '✓'       : '🎁';
    var iconShadow = isUnlocked ? 'box-shadow:0 1px 3px rgba(0,0,0,0.25);' : '';

    var imageHTML = '<div style="position:relative;flex-shrink:0;width:52px;height:68px;">'
      + '<img src="' + GIFT_IMAGE + '" alt="Pamper Packed Gift Set" style="width:100%;height:100%;object-fit:cover;border-radius:5px;" />'
      + '<span aria-hidden="true" style="position:absolute;top:-5px;left:-5px;width:18px;height:18px;border-radius:50%;background:' + iconBg + ';color:' + iconColor + ';display:inline-flex;align-items:center;justify-content:center;font-size:11px;font-weight:600;' + iconShadow + '">' + iconSymbol + '</span>'
      + '</div>';

    var textHTML = isUnlocked
      ? '<span>You\'ve unlocked a <strong>FREE Gift Box Set</strong>!</span>'
      : '<span>Add <strong>' + formatMoney(remaining) + ' more</strong> to unlock your <strong>FREE Pamper Packed Gift Set</strong> <span style="opacity:0.75;">(Valued at $60)</span></span>';

    var mainHTML = '<div style="display:flex;align-items:center;gap:12px;">'
      + imageHTML
      + '<div style="display:flex;align-items:center;gap:10px;">' + textHTML + '</div>'
      + '</div>';

    document.querySelectorAll('.discount-block').forEach(function (block) {
      block.setAttribute('style', style);
      block.setAttribute('aria-live', 'polite');
      block.innerHTML = mainHTML;
    });
  }

  function refreshBlock() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderBlocks(cart.total_price);
      })
      .catch(function (err) {
        renderBlocks(0);
        console.error('[GiftBlock] Cart fetch error', err);
      });
  }

  document.addEventListener('DOMContentLoaded', refreshBlock);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="add"],' +
      'button[data-add-to-cart],' +
      'form[action*="/cart/add"] button[type="submit"],' +
      'form[action*="/cart/add"] input[type="submit"],' +
      'button[name="plus"],' +
      'button[name="minus"],' +
      '.quantity__button'
    );
    if (!btn) return;
    setTimeout(refreshBlock, 800);
  });

  ['cart:refresh', 'cart:change', 'cart:updated', 'cart:item-added', 'theme:cart:change', 'ajaxCart:updated'].forEach(function (evt) {
    document.addEventListener(evt, refreshBlock);
  });

  window.GiftBlock = { sync: refreshBlock };
})();